import { useEffect } from "react";
const PIXEL_ID = "1252242806993118";
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const w = window as unknown as {
      fbq?: (...args: unknown[]) => void;
    };
    if (w.fbq) {
      w.fbq("track", "PageView");
      return;
    }

    /* Meta Pixel base code */
    (function (f: any, b: Document, e: string, v: string) {
      let n: any;
      let t: HTMLScriptElement;
      let s: Element | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    w.fbq!("init", PIXEL_ID);
    w.fbq!("track", "PageView");
  }, []);
  return <noscript data-id="element-176" data-mp="13hyqq929kn4n">
      <img height="1" width="1" style={{
      display: "none"
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-177" data-mp="13i8a3dsszw1d" />
    </noscript>;
}